export default class DynamicLeaves {
  get key() {
    return 'dynamicLeaves';
  }

  shouldBeLeaf(treeState, nodeId, { plugins }) {
    const { children } = treeState;
    const { filter } = plugins;

    const nodeChildren = children[nodeId];

    if (treeState.models[nodeId] && treeState.models[nodeId].hasChildren) {
      return false;
    }

    if (
      nodeChildren === undefined ||
      (treeState.models[nodeId] &&
        treeState.models[nodeId].hasChildren === false)
    ) {
      return true;
    }

    if (Array.isArray(nodeChildren)) {
      return (
        !nodeChildren.length ||
        (filter &&
          nodeChildren.every(id => !filter.nodeIsVisible(treeState, id)))
      );
    }

    return false;
  }
}
